module.exports = __webpack_public_path__ + "static/media/loader.7b1bc51d.svg";